import React from "react";
import { toast } from 'react-toastify';
import { ReactSession } from "react-client-session";

import { Helpers } from "../config/Helpers";
import { Whatsapp } from 'react-social-sharing';
import $ from "jquery";

class Product extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            productId: '',
            productName: '',
            productCategory: '',
            productJenis: '',
            productImage: '',
            productWishlist: '',
            productDetailData: [],
            relatedProducts: [],
            description: '',
            isMore: false,
            detailId: '',
            stokPerUnit: '',
            stokPerUnitBase: '',
            StokPerUnitReal: '',
            qtyOrder: 0,
            priceOrder: 0,
            priceOrderTotal: '0',
            orderType: (ReactSession.get("order_type")) ? ReactSession.get("order_type") : 'Grosir',
            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : 'CBNG-18-020001',
            infinity: false
        };
    }

    componentDidMount() {
        this.setupProduct();

        setTimeout(() => {
            $('a[aria-label="Share on WhatsApp"]').find('svg').css({
                width: '20px',
                height: '20px'
            });
            $('a[aria-label="Share on WhatsApp"]').css({
                marginBottom: '7px'
            });
        }, 500);
    }
    setupProduct = () => {
        let checkProductId = ReactSession.get("product_id");
        if (checkProductId) {
            this.setState({
                productId: checkProductId,
                productName: ReactSession.get("product_name"),
                productCategory: ReactSession.get("product_category"),
                productJenis: ReactSession.get("product_jenis"),
                productImage: ReactSession.get("product_image").replaceAll(" ", "%20")
            }, () => {
                Helpers.getProductDetails(this.state.sessEmail, this.state.productId, this.state.branchCode, 'yes').then(res => {
                    this.setState({
                        productDetailData: res,
                        productWishlist: (res[0].KodeWishlist == 'null') ? '' : res[0].KodeWishlist,
                        description: res[0].Keterangan,
                        isMore: false,
                        detailId: res[0].DetailId,
                        stokPerUnit: res[0].StokPerUnit,
                        stokPerUnitBase: res[0].StokPerUnit,
                        StokPerUnitReal: res[0].StokPerUnitReal,
                        qtyOrder: 0,
                        priceOrder: res[0].HargaGrosirFormatTerkecilRaw,
                        priceOrderTotal: '0',
                        infinity: (res[0].StokPerUnit > 0) ? false : true
                    });
                });

                // related products for "Cek produk serupa lainnya, yuk"
                Helpers.getProductSimiliar("", this.state.branchCode, "", this.state.productCategory, "").then(res => {
                    this.setState({ relatedProducts: res });
                });
            });
        }
    };

    handleRadioChange = (object, orderType) => {
        this.setState({
            detailId: object.DetailId,
            stokPerUnit: object.StokPerUnit,
            stokPerUnitBase: object.StokPerUnit,
            StokPerUnitReal: object.StokPerUnitReal,
            orderType: orderType,
            priceOrder: (orderType == 'Grosir') ? object.HargaGrosirFormatTerkecilRaw : object.HargaRetailFormatTerkecilRaw,
            qtyOrder: 0,
            priceOrderTotal: '0'
        });
    };

    handleQtyChange = (direction) => {
        if (this.state.detailId) {
            let countQty = 0;
            if (direction == 'plus') {
                countQty = this.state.qtyOrder + 1;
                if (this.state.StokPerUnitReal > 0 && countQty >= this.state.StokPerUnitReal) {
                    countQty = this.state.StokPerUnitReal;
                }
            } else {
                countQty = this.state.qtyOrder - 1;
                if (countQty < 0) countQty = 0;
            }

            let sisaStok = this.state.infinity
                ? this.state.stokPerUnitBase
                : Math.max(this.state.stokPerUnitBase - countQty, 0);

            this.setState({
                qtyOrder: countQty,
                stokPerUnit: sisaStok,
                priceOrderTotal: (countQty * this.state.priceOrder)
                    .toLocaleString(undefined, { maximumFractionDigits: 0 })
                    .toString()
                    .replaceAll(',', '.')
            });
        } else {
            toast.error("Anda belum memilih jenis unit");
        }
    };

    handleSubmitOrderTemp = () => {
        if (!this.state.detailId) {
            toast.error("Anda belum memilih jenis unit");
            return;
        }
        if (parseInt(this.state.qtyOrder) <= 0) {
            toast.error("Anda belum mengisi quantity");
            return;
        }

        Helpers.createOrderTemp(this.state.sessEmail, this.state.detailId, this.state.qtyOrder, this.state.branchCode, 'yes').then(res => {
            if (res[0].alert == 'success') {
                this.setState({ qtyOrder: 0, priceOrderTotal: '0' });
                ReactSession.set("update_dropdown_cart", "t");
            }
            toast[res[0].alert](res[0].message);
        });
    };

    handleProductClick = (object) => {
        ReactSession.set("product_id", object.KodeBarang);
        ReactSession.set("product_name", object.NamaBarang);
        ReactSession.set("product_category", object.KategoriBarang);
        ReactSession.set("product_jenis", object.JenisBarang);
        ReactSession.set("product_image", object.img_url);

        this.setState({
            productDetailData: [],
            description: '',
            isMore: false,
            detailId: '',
            qtyOrder: 0,
            priceOrder: 0,
            priceOrderTotal: '0',
            productWishlist: ''
        }, () => {
            this.setupProduct();
            window.scrollTo(0, 0);
        });
    };

    handleWishlist = () => {
        Helpers.manageWishlist(
            this.state.productWishlist,
            this.state.sessUserCode,
            this.state.productId,
            this.state.productWishlist ? 'delete' : 'insert'
        ).then(res => {
            if (res[0].alert == 'success') {
                Helpers.getProductDetails(this.state.sessEmail, this.state.productId, this.state.branchCode, 'yes').then(res2 => {
                    this.setState({ productWishlist: (res2[0].KodeWishlist == 'null') ? '' : res2[0].KodeWishlist });
                });
            }
            toast[res[0].alert](res[0].message);
        });
    };

    handleBack = () => {
        window.history.back();
    };

    handleChatClick = () => {
        window.location.href = './chat';
    };

    more = () => {
        this.setState({ isMore: true });
    };

    less = () => {
        this.setState({ isMore: false });
    };

    handleQtyInput = (value) => {
        if (!this.state.detailId) {
            toast.error("Anda belum memilih jenis unit");
            return;
        }

        let countQty = parseInt(value) || 0;
        if (countQty < 0) countQty = 0;

        if (!this.state.infinity && this.state.StokPerUnitReal > 0 && countQty > this.state.StokPerUnitReal) {
            countQty = this.state.StokPerUnitReal;
        }

        const sisaStok = this.state.infinity
            ? this.state.stokPerUnitBase
            : Math.max(this.state.stokPerUnitBase - countQty, 0);

        this.setState({
            qtyOrder: countQty,
            stokPerUnit: sisaStok,
            priceOrderTotal: (countQty * this.state.priceOrder)
                .toLocaleString(undefined, { maximumFractionDigits: 0 })
                .toString()
                .replaceAll(',', '.')
        });
    };

    handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: this.state.productName,
                url: window.location.href
            });
        }
    };

    render() {
        const { productDetailData } = this.state;

        return (
            <>
                <div className="product-outer">
                    <div className="product-page">
                        {/* Header */}
                        <div className="product-header">
                            <i className="fi-rs-arrow-small-left product-header-icon" onClick={this.handleBack}></i>
                            <div className="product-header-actions">
                                <Whatsapp solid small message={this.state.shareMessage} link={'https://waroq.com/'}/>
                            </div>
                        </div>

                        {/* Product image */}
                        <div className="product-image-wrap">

                            <img src={this.state.productImage} className="product-image" alt={this.state.productName} />
                        </div>

                        {/* Title / category */}
                        <div className="product-info-block">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <h4 className="product-name">{this.state.productName}</h4>
                                <i
                                    className={`product-heart-icon ${this.state.productWishlist ? 'fi-ss-heart' : 'fi-rs-heart'}`}
                                    style={{ color: '#F47626' }}
                                    onClick={this.handleWishlist}
                                ></i>
                            </div>
                            <div className="product-meta-row">
                                <span className="product-meta-label">Jenis</span>
                                <span className="product-meta-value">{this.state.productJenis}</span>
                            </div>
                            <div className="product-meta-row">
                                <span className="product-meta-label">Kategori</span>
                                <span className="product-meta-value">{this.state.productCategory}</span>
                            </div>
                        </div>

                        {/* Deskripsi */}
                        {
                            this.state.description && (
                                <div className="product-desc-block">
                                    <h6 className="product-desc-title">Produk Deskripsi</h6>
                                    <p className="product-desc-text">
                                        {
                                            !this.state.isMore ? (
                                                <>
                                                    {this.state.description.substring(0, 140)}
                                                    <a href="javascript:void(0);" className="product-desc-toggle" onClick={this.more}> show more..</a>
                                                </>
                                            ) : (
                                                <>
                                                    {this.state.description}
                                                    <a href="javascript:void(0);" className="product-desc-toggle" onClick={this.less}> show less</a>
                                                </>
                                            )
                                        }
                                    </p>
                                </div>
                            )
                        }

                        {/* Grosir / Retail */}
                        <div className="product-price-columns">
                            <div className="product-price-col">
                                <h6 className="product-price-header">Grosir <span className="product-badge" style={{ backgroundColor: '#F15D30' }}>G</span></h6>
                                {productDetailData.map((object, i) => (
                                    <label key={'g' + i} className="product-price-option">
                                        <input
                                            type="radio"
                                            name="jenisorder"
                                            className="product-radio"
                                            checked={this.state.detailId == object.DetailId && this.state.orderType == 'Grosir'}
                                            onChange={() => this.handleRadioChange(object, 'Grosir')}
                                        />
                                        <div>
                                            <div className="product-price-value">Rp {object.HargaGrosirFormatTerkecil}</div>
                                            <div className="product-price-unit">{object.UnitBarang} ({object.PcsPerUnit} Pcs - {(object.BeratPerUnit / 1000)}gr)</div>
                                        </div>
                                    </label>
                                ))}
                            </div>
                            <div className="product-price-col right">
                                <h6 className="product-price-header">Retail <span className="product-badge" style={{ backgroundColor: '#5CB85C' }}>R</span></h6>
                                {productDetailData.map((object, i) => (
                                    <label key={'r' + i} className="product-price-option">
                                        <input
                                            type="radio"
                                            name="jenisorder"
                                            className="product-radio"
                                            checked={this.state.detailId == object.DetailId && this.state.orderType == 'Retail'}
                                            onChange={() => this.handleRadioChange(object, 'Retail')}
                                        />
                                        <div>
                                            <div className="product-price-value">Rp {object.HargaRetailFormatTerkecil}</div>
                                            <div className="product-price-unit">{object.UnitBarang} ({object.PcsPerUnit} Pcs - {(object.BeratPerUnit / 1000)}gr)</div>
                                        </div>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Stock + Qty */}
                        <div className="product-stock-qty-row">
                            <div className="product-stock-qty-col">
                                <p className="product-small-label">Stok Tersedia</p>
                                <div className="product-stock-box">{this.state.infinity ? '∞' : this.state.stokPerUnit}</div>
                            </div>
                            <div className="product-stock-qty-col">
                                <p className="product-small-label">Jumlah Pesanan</p>
                                <div className="product-qty-box">
                                    <button className="product-qty-btn" onClick={() => this.handleQtyChange('minus')}>-</button>
                                    <input className="product-qty-input" type="number" value={this.state.qtyOrder} onChange={(e) => this.handleQtyInput(e.target.value)} />
                                    <button className="product-qty-btn plus" onClick={() => this.handleQtyChange('plus')}>+</button>
                                </div>
                            </div>
                        </div>

                        {
                            this.state.infinity && (
                                <div className="product-info-box">
                                    <i className="fi-rs-info"></i>
                                    <span>{this.state.productName} saat ini hanya tersedia untuk Pre Order, barang Pre Order membutuhkan waktu lebih lama saat pengiriman.</span>
                                </div>
                            )
                        }

                        <div className="product-related-block">
                            <div className="product-related-header">
                                <h4 className="product-related-title">Cek produk serupa lainnya, yuk</h4>
                                <i className="fi-rs-angle-small-right product-related-arrow"></i>
                            </div>
                            <div className="product-related-scroll">
                                {this.state.relatedProducts.map((object, i) => (
                                    <div key={i} className="product-related-card" onClick={() => {this.handleProductClick(object)}}>
                                        <img src={object.img_url} className="product-related-image" alt=""/>
                                        <div className="product-related-name">{object.NamaBarang}</div>
                                        <div className="product-related-price">Rp {object.HargaGrosirFormatTerkecil}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="product-bottom-bar">
                            <div className="product-chat-circle" onClick={this.handleChatClick}>
                                <i className="fi-rs-comment-alt"></i>
                            </div>
                            <div style={{ flex: 1, marginLeft: '15px' }}>
                                <div className="product-total-label">Total</div>
                                <div className="product-total-value">Rp {this.state.priceOrderTotal}</div>
                            </div>
                            <button className="product-cart-button" onClick={this.handleSubmitOrderTemp}>+ Keranjang</button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Product;